import { Action, History, Location } from 'history';
import * as ReactGA from 'react-ga';
import {
  RouterStore as BaseRouterStore,
  syncHistoryWithStore,
  SynchronizedHistory
} from 'mobx-react-router';
import { observable } from 'mobx';

const MAX_LOCATION_HISTORY_LENGTH = 100;

export class RouterStore extends BaseRouterStore {
  public history: SynchronizedHistory;
  @observable public locationHistory: Array<string>;

  constructor(history?: History) {
    super();
    if (history) {
      this.history = syncHistoryWithStore(history, this);

      this.locationHistory = [this.history.location.pathname];

      this.history.subscribe((location: Location, action: Action) => {
        // Record ga pages only on production & staging
        if (
          process.env.NODE_ENV === 'production' ||
          process.env.NODE_ENV === 'staging'
        ) {
          ReactGA.set({ page: location.pathname });
          ReactGA.pageview(location.pathname);
        }

        this.pushLocation(location, action);
      });
    }
  }

  private pushLocation = (location: Location, action: Action): void => {
    switch (action) {
      case 'PUSH':
        this.locationHistory.push(location.pathname);

        if (this.locationHistory.length > MAX_LOCATION_HISTORY_LENGTH) {
          this.locationHistory.shift();
        }

        break;
      case 'POP':
        // HACK: Ignore pop if it's for the first item - we don't ever want to
        // clear that, and pop also seems to fire immediately on page load...
        if (this.locationHistory.length > 1) {
          this.locationHistory.pop();
        }
        break;

      case 'REPLACE':
        this.locationHistory.splice(
          this.locationHistory.length - 1,
          1,
          location.pathname
        );
        break;

      default:
      // no-op
    }
  };
}

export default RouterStore;



// WEBPACK FOOTER //
// ./src/app/stores/RouterStore.ts